import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationSpotDragnDrop = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationSpotDragnDrop"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        d="M65.66 3.94H12.77v3.71l-5.24-.64-6.28 50.9 52.49 6.48 1.13-9.16h10.79z"
      />
      <path fill="#fff" d="M63.66 53.23H14.77V5.94h48.89v47.29" />
      <path
        fill="#B7E854"
        d="M53.19 27.46H41.34V15.6h-4.25v11.86H25.23v4.25h11.86v11.86h4.25V31.71h11.85z"
      />
      <path
        fill="#27DBA8"
        d="M14.77 53.23V9.92l-5.5-.68-5.79 46.93L52 62.16l1.1-8.93z"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M41.84 44.07h-5.25V32.21H24.73v-5.25h11.86V15.1h5.25v11.86H53.7v5.25H41.84zm-4.25-1h3.25V31.21H52.7v-3.25H40.84V16.1h-3.25v11.86H25.73v3.25h11.86z"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M64.16 5.44H14.27v3.91l-5.43-.67-5.92 47.93 49.51 6.11 1.11-8.98h10.61V5.44zM51.57 61.6 4.04 55.74 9.71 9.79l4.56.56v43.37h38.27l-.97 7.87zm11.59-8.87H15.27V6.44h47.89z"
      />
    </svg>
  );
};
export default IllustrationSpotDragnDrop;
